module.exports = __webpack_public_path__ + "static/media/next-icon.f7fdf2e7.svg";